import Id from './Id';
import Created from './Created';
import PlateNumber from './PlateNumber';
import Updated from './Updated';
import Make from './Make';
import Model from './Model';
import InDate from './InDate';
import OutDate from './OutDate';

export const labels = {
  Id: 'Azonosító',
  PlateNumber: 'Rendszám',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
  Make: 'Márka',
  Model: 'Modell',
  InDate: 'Bekerülés dátum',
  OutDate: 'Kikerülés dátum',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'PlateNumber',
  fixed: true,
}, {
  value: 'Updated',
}, {
  value: 'Created',
},  {
  value: 'Make',
},  {
  value: 'Model',
},  {
  value: 'InDate',
}, {
  value: 'OutDate',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
},  {
  value: 'PlateNumber',
  fixed: true,
},  {
  value: 'Make',
},  {
  value: 'Model',
},  {
  value: 'InDate',
},  {
  value: 'OutDate',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultSort = {
  prop: PlateNumber.propName,
  order: 'ascending'
};

export default {
  Id,
  Created,
  Updated,
  PlateNumber,
  Make,
  Model,
  InDate,
  OutDate,
};
